import * as React from 'react'
import { Badge } from '@/shared/ui'

export function SoftColorBordered() {
  return (
    <div className="inline-space flex flex-wrap gap-2">
      <Badge variant="soft" color="primary">Primary</Badge>
      <Badge variant="soft" color="secondary">Secondary</Badge>
      <Badge variant="soft" color="info">Info</Badge>
      <Badge variant="soft" color="success">Success</Badge>
      <Badge variant="soft" color="warning">Warning</Badge>
      <Badge variant="soft" color="error">Error</Badge>
    </div>
  )
}

